import React from "react";
import "./index.scss";
const PageHeader = ({ children, className = '' }) => (
	<>
		<div className={`page-header ${className}`}>
			<h2 className="d-flex align-items-center">{children}</h2>
		</div>
	</>
);
export default PageHeader;